import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Alert, Col, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import {useSelector} from "react-redux";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import useAfterUpdateEffect from "../../../../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

const AutoLand = props => {
  const { t } = useTranslation('supplier_create')
  const user = useSelector(state => state.user)
  const [data, setData] = useState({
    login: '',
    email: user.email,
  })

  useDidMountEffect(() => {
    props.onChange(data)
  })

  useAfterUpdateEffect(() => {
    props.onChange(data)
  }, [data])

  return <React.Fragment>
    <Alert color={'info'}>
      <span>{t('supplier.autoLand.text1')}</span>
    </Alert>
    <FormGroup row>
      <Label md={3}>{t('supplier.autoLand.login')}</Label>
      <Col md="9">
        <Input
          invalid={!!props.errors?.login?.errors}
          placeholder="Login w AutoLand"
          onChange={e => setData({...data, login: e.target.value,})}
          value={data.login}
        />
        <FormFeedback>{props?.errors?.login?.errors?.join('; ')}</FormFeedback>
      </Col>
    </FormGroup>
    <FormGroup row>
      <Label md={3}>
        <span>{t('supplier.autoLand.email')}</span>
        <div style={{ lineHeight: '10px'}}>
          <small className="text-secondary">{t('supplier.autoLand.email_hint')}</small>
        </div>
      </Label>
      <Col md="9">
        <Input
          invalid={!!props.errors?.email?.errors}
          placeholder={t('supplier.autoLand.email_placeholder')}
          onChange={e => setData({...data, email: e.target.value,})}
          value={data.email}
        />
        <FormFeedback>{props?.errors?.email?.errors?.join('; ')}</FormFeedback>
      </Col>
    </FormGroup>
  </React.Fragment>
};

AutoLand.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default AutoLand;